import React from 'react';
import './FooterComponent.css';
import {IonToolbar, IonFooter, IonTabBar, IonTabButton, IonImg, IonLabel} from '@ionic/react';

const FooterCom: React.FC = () => {
        return (
            <IonFooter className="footer">
                <IonToolbar>
                    <IonTabBar className="tabbar">
                            <IonTabButton tab="tab1" href="/mindset"><IonImg src="../assets/images/icons/mindset.png" alt="Mindset" className="icon"/><IonLabel className="label">Mindset</IonLabel></IonTabButton>
                            <IonTabButton tab="tab2" href="/plan"><IonImg src="../assets/images/icons/plan.png" alt="Plan" className="icon"/><IonLabel className="label">Plan</IonLabel></IonTabButton>
                            <IonTabButton tab="" href="/dashboard"><IonImg src="../assets/images/icons/compass-nbkg.png" alt="compass" className="compass"/></IonTabButton>
                            <IonTabButton tab="tab3" href="/explore"><IonImg src="../assets/images/icons/explore.png" alt="Explore" className="icon"/><IonLabel className="label">Explore</IonLabel></IonTabButton>
                            <IonTabButton tab="tab4" href="/analyze"><IonImg src="../assets/images/icons/analyse.png" alt="Analyse" className="icon"/><IonLabel className="label">Analyze</IonLabel></IonTabButton>
                    </IonTabBar>
                </IonToolbar>
            </IonFooter>
        );
};
export default FooterCom;